<template>
  <div>
    <div
      class="profile-pic"
      @click="trigger"
      :style="{ backgroundImage: 'url(' + image + ')' }"
    >
      <input
        id="imageUpload"
        ref="fileInput"
        type="file"
        name="profile_photo"
        accept="image/*"
        @change="croppie"
      />
      <div class="label-wrapper">
        <div class="change-image">
          <div class="row">
            <v-icon color="white" small>image</v-icon>
            <span>ändern</span>
          </div>
        </div>
      </div>
      <!-- <div ref="blue-ring" class="profile-active" v-if="accountActive"></div>
      <div ref="blue-ring2" class="profile2-active" v-if="accountActive"></div> -->
    </div>

    <CroppieDialog
      ref="croppieDialog"
      :image="imageSrc"
      :show.sync="showCroppie"
      @upload="cropGalleryOrProfilPhoto"
    />
  </div>
</template>

<script>
import croppieMixin from '../../mixins/croppie';
import CroppieDialog from '../dialogs/CroppieDialog';

export default {
  props: ['image', 'accountActive'],

  mixins: [croppieMixin],

  components: {
    CroppieDialog,
  },

  methods: {
    trigger(img) {
      if (['0', '1', '2', '3'].includes(img)) {
        this.galleryImg = img;
      }
      this.$refs.fileInput.click();
    },
  },

  mounted() {
    // if (!this.$store.state.blueRingShowed) {
    //   this.$refs['blue-ring'].classList.add('profile-active__effect');
    //   this.$refs['blue-ring2'].classList.add('profile2-active__effect');
    //   setTimeout(() => {
    //     this.$refs['blue-ring'].classList.remove('profile-active__effect');
    //     this.$refs['blue-ring2'].classList.remove('profile2-active__effect');
    //     this.$store.state.blueRingShowed = true;
    //   }, 5000);
    // }
  },
};
</script>

<style lang="scss" scoped>
@import '@/styles/blue-ring.scss';

.profile-active {
  width: 128px;
  height: 128px;
  top: -4px;
  left: -4px;
  border-radius: 50%;
  position: absolute;
  border: 3px solid #4575bc;
  box-shadow: 0 0 8px #4575bc;
  &__effect {
    width: 120px;
    height: 120px;
    border: 0px;
    left: 0;
    top: 0;
    border: 2px solid #4575bc;
    @include pulse;
  }
}

.profile2-active {
  // width: 132px;
  // height: 132px;
  // top: -6px;
  // left: -6px;
  border-radius: 50%;
  position: absolute;
  // border: 2px solid #6c9adf;

  &__effect {
    width: 120px;
    height: 120px;
    border: 0px;
    left: 0;
    top: 0;
    border: 1px solid #79a9f0;
    @include pulse2;
  }
}

.profile-pic {
  position: relative;
  width: 120px;
  height: 120px;
  background-size: cover;
  margin: auto;
  background-position: top;
  border-radius: 50%;
  // overflow: hidden;
  // border: 1px solid #e7e7e7;

  #imageUpload {
    display: none;
  }

  .label-wrapper {
    overflow: hidden;
    width: 120px;
    height: 120px;
    border-radius: 50%;
    position: relative;
  }

  .change-image {
    cursor: pointer;
    position: absolute;
    background: rgba(0, 0, 0, 0.637);
    color: white;
    display: flex;
    justify-content: center;
    align-items: flex-start;
    bottom: 0;
    right: 0;
    width: 100%;
    height: 20%;

    .row {
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 11px;
    }
  }
}
</style>
